module.exports = __webpack_public_path__ + "static/media/Web_Track_Icon.d5c1c706.svg";